import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._placeholder = options.placeholder;
        this._cta = options.cta;
        this._ctaReset = options.reset;
        this._structureKeys = options.structureKeys;
        this._showSiteUrl = options.showSiteUrl;
        this._categories = JSON.parse(options.categories);
        this._documentFolders = JSON.parse(options.documentFolders);
        this._groupId = options.groupId;
        this._fileEntryTypeId = options.fileEntryTypeId;
        this._searchString = writable('');
        this._kategorie = writable('');
        this._utvar = writable('');
        this._rok = writable('');
        this._platnost = writable('');
    }
    resetFilter() {
        this.searchString = '';
        this.kategorie = '';
        this.utvar = '';
        this.rok = '';
        this.platnost = '';
    }
    getCategoryAttributeBySlug(slug, attribute) {
        if (!slug || !attribute)
            return undefined;
        const category = this.categories.find(item => item.slug === slug);
        if (!category)
            return undefined;
        return category[attribute];
    }
    isWo() {
        const attributeValue = this.getCategoryAttributeBySlug(this.kategorie, 'wo');
        if (typeof attributeValue !== 'boolean')
            return undefined;
        return attributeValue;
    }
    getCategorySortBy() {
        const attributeValue = this.getCategoryAttributeBySlug(this.kategorie, 'sortBy');
        if (!Array.isArray(attributeValue))
            return undefined;
        return attributeValue
            .map((item) => item.trim())
            .filter((item) => !!item);
    }
    getFolderAttributeBySlug(slug, attribute) {
        if (!slug || !attribute)
            return undefined;
        const folder = this.documentFolders.find(item => item.slug === slug);
        if (!folder)
            return undefined;
        return folder[attribute];
    }
    get isFilterActive() {
        return !!(this.kategorie || this.utvar || this.rok || this.platnost || this.searchString);
    }
    get placeholder() {
        return this._placeholder;
    }
    get cta() {
        return this._cta;
    }
    get ctaReset() {
        return this._ctaReset;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get categories() {
        return this._categories;
    }
    get documentFolders() {
        return this._documentFolders;
    }
    get groupId() {
        return this._groupId;
    }
    get fileEntryTypeId() {
        return this._fileEntryTypeId;
    }
    // searchString
    set searchString(string) {
        this._searchString.set(string);
    }
    get searchStringSubs() {
        return this._searchString;
    }
    get searchString() {
        return get(this._searchString);
    }
    get searchParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("q") || "";
    }
    // kategorie
    set kategorie(value) {
        this._kategorie.set(value);
    }
    get kategorie() {
        return get(this._kategorie);
    }
    get kategorieParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const kategorie = urlParams.get("kategorie");
        return kategorie && this.categories.some(item => String(item.slug) === kategorie) ? kategorie : '';
    }
    // utvar
    set utvar(value) {
        this._utvar.set(value);
    }
    get utvar() {
        return get(this._utvar);
    }
    get utvarParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const utvar = urlParams.get("utvar");
        return utvar && this.documentFolders.some(item => String(item.slug) === utvar) ? utvar : '';
    }
    // rok
    set rok(value) {
        this._rok.set(value);
    }
    get rok() {
        return get(this._rok);
    }
    get rokParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const rok = urlParams.get("rok");
        return rok || '';
    }
    // platnost
    set platnost(value) {
        this._platnost.set(value);
    }
    get platnost() {
        return get(this._platnost);
    }
    get platnostParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const platnost = urlParams.get("platnost");
        return platnost || '';
    }
    // common
    get pageParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("strana");
        return page ? parseInt(page) : 1;
    }
    get pageSizeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageSize = urlParams.get("pocet");
        return pageSize ? parseInt(pageSize) : 10;
    }
    get apiStructureKeys() {
        if (typeof this._structureKeys === "string") {
            return this._structureKeys.split("|");
        }
        else {
            return [];
        }
    }
}
